import httpService from "services/httpService";

const baseApiEndPoint = process.env.REACT_APP_API_ENDPOINT;

const apiEndPoint = baseApiEndPoint + "/invoiceReconciliation";

export async function uploadInvoiceDocument(formData) {
    const {data} = await httpService.post(
        apiEndPoint + "/invoice/november",
        formData
    );
    return data;
}

export async function finalizeReconciledInvoices(details) {
    const {data} = await httpService.put(
        apiEndPoint + "/close_waybills",
        details
    );
    return data;
}

export default {
    uploadInvoiceDocument,
    finalizeReconciledInvoices,
};
